'use strict';

// This class attempts to centralize some functionality for the insights widgets.
// Add to it as you're able!
angular.module('MW.InsDashboard.TransformSentiment', [
    'DashboardChartConfigService',
    'MW.InsDashboard.ChartDataService',
    'MW.Framework.TranslationService',
    'CoreColorService'
])
.factory('TransformSentiment', [
    'DashboardChartConfigService',
    'ChartDataService',
    'translationService',
    'CoreColorService',
    function (
        DashboardChartConfigService,
        ChartDataService,
        translationService,
        CoreColorService) {

    var transformSentiment = {};

    // Formulate the data from the backend service into something we can more easily graph.
    var formulateData = function formulateData(raw_data, chart) {
        var previousPositiveSentiment = 0,
            previousNegativeSentiment = 0,
            posPercentageOfTotal = 0,
            negPercentageOfTotal = 0,
            sumTotal = 0,
            posVal,
            negVal,//used to switch between percent and counts instead of keeping two separate arrays of data
            positiveSentiments = [],
            negativeSentiments = [],
            data = parseRequestData(raw_data),
            categories =  ChartDataService.setDateAxis(data, chart);

        for (var i = 0; i < data.length; i++) {

            var volume = data[i]['volume'];

            var diffPos,diffNeg;
            if (i == 0) {
                diffPos = diffNeg = ' ';
            } else {
                if (volume.p > previousPositiveSentiment)
                    diffPos = (previousPositiveSentiment == 0) ? volume.p * 100 : ((Math.round(volume.p /  previousPositiveSentiment)) - 1) * 100;
                else
                    diffPos = (volume.p == 0) ? previousPositiveSentiment * -100 : ((Math.round(previousPositiveSentiment / volume.p  )) - 1) * -100;

                if (volume.v > previousNegativeSentiment)
                    diffNeg = (previousNegativeSentiment == 0) ? volume.v * -100 : ((Math.round(volume.v /  previousNegativeSentiment)) - 1) * -100;
                else
                    diffNeg = (volume.v == 0) ? previousNegativeSentiment * 100 : ((Math.round(previousNegativeSentiment / volume.v )) - 1) * 100;
            }

            sumTotal = volume.p + volume.v;
            posPercentageOfTotal = (volume.p == 0 || sumTotal == 0) ? 0 : Math.round(volume.p / sumTotal * 100);
            negPercentageOfTotal = (volume.v == 0 || sumTotal == 0) ? 0 : Math.round(volume.v / sumTotal * 100);

            posVal = volume.p;
            negVal = volume.v;


            if(chart.percent) {
                posVal = posPercentageOfTotal;
                negVal = negPercentageOfTotal;
            }

            //added the count. The perc and count are clean unchanged values that are mostly used for the tool tips
            positiveSentiments.push({x: i, y: posVal, marker: null, diff: diffPos, perc : posPercentageOfTotal, count: volume.p, color: CoreColorService.getPositiveColor('default'), date: data[i].date});
            negativeSentiments.push({x: i, y: negVal, marker: null, diff: diffNeg, perc : negPercentageOfTotal, count: volume.v, color: CoreColorService.getNegativeColor('default'), date: data[i].date});

            previousPositiveSentiment = volume.p;
            previousNegativeSentiment = volume.v;
        };

        return {
            positiveSentiments: positiveSentiments,
            negativeSentiments: negativeSentiments,
            dateCategories: categories
        };

    };

    var formulateDonutData = function formulateDonutDate(raw_data, chart) {
        var donutData = [],
            donutPositive = 0,
            donutNegative = 0,
            donutNeutral = 0,
            data = parseRequestData(raw_data);

        for (var i = 0; i < data.length; i++) {
            if(data[i].volume !== 0 ) {
                var volume = data[i].volume;
                donutPositive += volume.p;
                donutNegative += volume.v;
                donutNeutral += volume.n;
            }
        }

        donutData.push({name:translationService.getLocalizedString('Positive'), y:donutPositive, sentiment: 'P', color: CoreColorService.getPositiveColor('default')});
        donutData.push({name:translationService.getLocalizedString('Negative'), y:donutNegative, sentiment: 'V', color: CoreColorService.getNegativeColor('default')});
        donutData.push({name:translationService.getLocalizedString('Neutral'), y:donutNeutral, sentiment: 'N', color: CoreColorService.getNeutralColor('default')});

        return donutData;

    };

    var getSentimentGraphObject = function getSentimentGraphObject(chartData) {
        return {
            series: [
                {
                    name: 'P',
                    data: chartData.positiveSentiments,
                    color: CoreColorService.getPositiveColor('default'),
                    showInLegend:false,
                    linkedTo:'P'
                },
                {
                    name: translationService.getLocalizedString('Positive'),
                    data: [null],
                    color: CoreColorService.getPositiveColor('default'),
                    marker: {symbol: 'circle'},
                    type: 'scatter',
                    id:'P'
                }, {
                    name: 'V',
                    data: chartData.negativeSentiments,
                    color: CoreColorService.getNegativeColor('default'),
                    showInLegend:false,
                    linkedTo:'V'
                },
                {
                    name: translationService.getLocalizedString('Negative'),
                    data: [null],
                    color: CoreColorService.getNegativeColor('default'),
                    marker: {symbol: 'circle'},
                    type: 'scatter',
                    id:'V'
                }
            ],
            xAxis: {
                categories: chartData.dateCategories
            }
        };

    };

    var getSentimentDonutGraphObject = function getSentimentDonutGraphObject(chartData) {
        return {
            series: [{
                data: chartData
            }]
        };

    };

    transformSentiment.column = function column(raw_data, chart) {

        var chartData = formulateData(raw_data, chart);

        // The column graph expects this data to be positive, which is the opposite of what the real value is.
        // Do a bit of quick transformation.
        angular.forEach(chartData.negativeSentiments, function forEachNegativeSentiments(sentiment) {
            sentiment.y *= -1;
        });

        chart.callback(getSentimentGraphObject(chartData));
    };

    transformSentiment.spline = function spline(raw_data, chart) {

        var chartData = formulateData(raw_data, chart);
        chart.callback(getSentimentGraphObject(chartData));
    };

    transformSentiment.donut = function donut(raw_data, chart) {
        var chartData = formulateDonutData(raw_data, chart);
        chart.callback(getSentimentDonutGraphObject(chartData));
    };

    var parseRequestData = function parseRequestData(dataSeries) {
        // There should only ever be one series since we limit you to one search. So, we can do this...
        return dataSeries[0].datapoints;

    };

    transformSentiment.pie = transformSentiment.donut;

    transformSentiment.table = function(raw_data, chart){
        chart.callback(processTable(raw_data, chart));
    }

    var processTable = function processTable(raw_data, chart) {
        var responseData = {},
            totalSentiment = 0,
            positiveCount = 0,
            negativeCount = 0,
            neutralCount = 0,
            totalPercent = 0,
            neuPercentageOfTotal = 0,
            posPercentageOfTotal = 0,
            negPercentageOfTotal = 0,
            data = parseRequestData(raw_data),
            tableData;

        //Manipulate table Data
        for(var i = 0; i < data.length; i++) {
            if(data[i].volume !== 0 ) {
                var volume = data[i].volume;
                positiveCount += volume.p;
                negativeCount += volume.v;
                neutralCount += volume.n;
            }
        }

        totalSentiment = positiveCount + negativeCount + neutralCount;

        neuPercentageOfTotal = (neutralCount == 0) ? 0 : parseFloat((neutralCount / totalSentiment * 100).toFixed(1));
        posPercentageOfTotal = (positiveCount == 0) ? 0 : parseFloat((positiveCount / totalSentiment * 100).toFixed(1));
        negPercentageOfTotal = (negativeCount.v == 0) ? 0 : parseFloat((negativeCount / totalSentiment * 100).toFixed(1));

        totalPercent = Math.round(neuPercentageOfTotal + posPercentageOfTotal + negPercentageOfTotal) + "%";
        neuPercentageOfTotal += "%";
        posPercentageOfTotal += "%";
        negPercentageOfTotal += "%";

        tableData = [{
                label: translationService.getLocalizedString("Neutral"),
                data: [{
                    name: raw_data[0].search.name,
                    sentimentCount: neutralCount,
                    sentimentPercent: neuPercentageOfTotal,
                    sentimentType: 'N'
                }]
            },{
                label: translationService.getLocalizedString("Positive"),
                data: [{
                    name: raw_data[0].search.name,
                    sentimentCount: positiveCount,
                    sentimentPercent: posPercentageOfTotal,
                    sentimentType: 'P'
                }]
            },{
                label: translationService.getLocalizedString("Negative"),
                data: [{
                    name: raw_data[0].search.name,
                    sentimentCount: negativeCount,
                    sentimentPercent: negPercentageOfTotal,
                    sentimentType: 'V'
                }]
            }];

        tableData.sort(function(a, b) {
            if(a.label === b.label) {
                return 0;
            } else {
                return (a.label < b.label) ? -1 : 1;
            }
        });

        responseData.table = tableData;
        responseData.countSummary = [totalSentiment];
        responseData.percentSummary = [totalPercent];
        return responseData;
    };


    return transformSentiment;

}]);
